import { render, staticRenderFns } from "./training-materials.vue?vue&type=template&id=a33fa46c&scoped=true&"
import script from "./training-materials.vue?vue&type=script&lang=js&"
export * from "./training-materials.vue?vue&type=script&lang=js&"
import style0 from "./training-materials.vue?vue&type=style&index=0&id=a33fa46c&lang=scss&scoped=true&"
import style1 from "./training-materials.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33fa46c",
  null
  
)

export default component.exports